import ResetPassword from './reset-password'
import Verify from './verify'
import { trackConversion } from '@/helpers/google-ads'
import FamilySession from '@/helpers/family-session'

// Fire any Google Ads conversions the backend flagged on the /token/valid response
// (e.g. first payment). The backend guarantees each conversion is signalled once.
function fireBackendConversions(response, user) {
    const conversions = response && response.data && response.data.fire_conversions
    if (!Array.isArray(conversions)) return
    conversions.forEach(c => {
        const params = { email: user && user.email }
        if (c.transaction_id) params.transaction_id = c.transaction_id
        trackConversion(c.event, params)
    })
}

export default {
    ...ResetPassword,
    ...Verify,
    
    checkAuth({commit}){
        let url = `/token/valid`,
            token = window.localStorage.getItem('tK');
        return new Promise((resolve, reject)=>{
            if (token){
                window.axios.post(url, {token}).then(response=>{
                    if (response.data.valid){
                        const user = response.data.user;
                        commit('SET_USER', user);
                        fireBackendConversions(response, user);

                        // set auth header on axios
                        window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                        // Check if there's a redirect instruction
                        const redirect = response.data.redirect || null;
                        resolve({authed: true, redirect});
                    }else{
                        commit('SET_USER', null);
                        
                        window.localStorage.removeItem('tK');
                        resolve({authed: false, redirect: 'login'});
                    }
                }).catch(error=>{
                    window.console.log(error);
                    reject(error);
                });
            }else{
                // no token, don't request validation so no user in state so not authed!
                resolve({authed: false});
            }
        })
    },
    refreshUser({commit}){
        let url = `/token/valid`,
            token = window.localStorage.getItem('tK');
        return new Promise((resolve, reject)=>{
            if (token){
                window.axios.post(url, {token}).then(response=>{
                    if (response.data.valid){
                        const user = response.data.user;
                        commit('SET_USER', user);
                        fireBackendConversions(response, user);
                        resolve();
                    }else{
                        reject();
                    }
                }).catch(error=>{
                    reject(error);
                });
            }else{
                // no token, don't request validation so no user in state so not authed!
                reject();
            }
        })
    },
    registerAction({commit}, payload){
        let url = `/register`;
        return new Promise((resolve, reject)=>{
            window.axios.post(url, payload).then(response=>{
                let token = response.data.token;
                if (token){
                    
                    window.localStorage.setItem('tK', token);
                    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    commit('SET_USER', response.data.user);
                    let redirectToVerify = response.data.verification === 'SENT';
                    resolve({redirect: redirectToVerify});
                }
            }).catch(error=>{
                reject(error);
            })
        });
    },
    loginAction({commit}, payload){
        let url = `/login`;
        return new Promise((resolve, reject)=>{
            
            window.axios.post(url, payload).then(response=>{
                let token = response.data.token;
                
                if (token){
                    window.localStorage.setItem('tK', token);
                    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    // a parent signing in with their own password is what earns
                    // the right to come back here after switching to a child
                    FamilySession.rememberIfParent(response.data.user, token);

                    commit('SET_USER', response.data.user);
                    resolve();
                }else{
                    reject({});
                }
            }).catch(error=>{
                reject(error);
            })
        });
    },
    logout({commit}){
        window.localStorage.removeItem('tK');
        FamilySession.forget();
        commit('SET_USER', null);
    },
    /**
     * Continue as another member of the family. The API hands back that
     * account's token, we put it where the app looks for it and reload, which
     * is how logout already resets everything.
     */
    switchFamilyAccount({commit}, payload){
        let url = '/childs/switch';

        return new Promise((resolve, reject)=>{
            window.axios.post(url, {user_id: payload.id}).then(response=>{
                const token = response.data.token;
                if (!token){
                    reject(response);
                    return;
                }

                window.localStorage.setItem('tK', token);
                resolve(response);
            }).catch(error=>{
                reject(error);
            })
        });
    },
    /**
     * Go back to the parent this device signed in as. No call to the API, the
     * token was saved at their own sign in.
     */
    switchBackToParent(){
        const parent = FamilySession.get();
        if (!parent) return false;

        window.localStorage.setItem('tK', parent.token);
        return true;
    }
}